module.exports = __webpack_public_path__ + "img/close.96a0bfef.png";